var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20C4.97656 20 0.5 15.5234 0.5 10C0.5 4.47656 4.97656 0 10.5 0C16.0234 0 20.5 4.47656 20.5 10C20.5 15.5234 16.0234 20 10.5 20ZM9.5625 4.6875V10C9.5625 10.3125 9.71875 10.6055 9.98047 10.7812L13.7305 13.2812C14.1602 13.5703 14.7422 13.4531 15.0312 13.0195C15.3203 12.5859 15.2031 12.0078 14.7695 11.7188L11.4375 9.5V4.6875C11.4375 4.16797 11.0195 3.75 10.5 3.75C9.98047 3.75 9.5625 4.16797 9.5625 4.6875Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchedule);
export default __webpack_public_path__ + "static/media/icon-schedule.4f11bd3575cceb123c371bfb02389dab.svg";
export { ForwardRef as ReactComponent };